import { render, staticRenderFns } from "./SaleReceivable.vue?vue&type=template&id=8e41ce84&scoped=true"
import script from "./SaleReceivable.vue?vue&type=script&lang=js"
export * from "./SaleReceivable.vue?vue&type=script&lang=js"
import style0 from "./SaleReceivable.vue?vue&type=style&index=0&id=8e41ce84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e41ce84",
  null
  
)

export default component.exports